const colorPrimaryDefault = '#2861f6'
const colorDefaultDefault = '#282829'
const colorHoverDefault = '#e2eaf3'
const colorDEefaultSecondary = '#8c8c8c'
const colorHoverStripe = '#f5f9fe'
const baseShadowColor = 'rgba(0, 0, 0, .1)'
const shadowTip = `0 4px 14px -1px ${baseShadowColor}`
const paddingLg = '32px'

export const them = {
  'color-purple-default': '#01b5ab', // 绿色 一级色

  'color-primary-gradient': `linear-gradient(145deg, #4888f2 0%, ${colorPrimaryDefault} 100%)`, /** 主色 渐变色 */

  'color-primary-default': colorPrimaryDefault, /** 主色 用于LOGO／ICON 用于按钮/导航栏press状态/文字按钮 */
  'color-primary-default-dark': '#4b75e2',
  'color-primary-middle': '#4888F2', /** 用于 辅助颜色 */
  'color-primary-middle-dark': '#6b96dd',
  'color-primary-secondary': '#e6f1fc', /** 多用于按钮二级底色 */

  'color-danger-default': '#ed473c', /** 用于涨幅数字／买入按钮／买入控件 */
  'color-danger-default-dark': '#d74238',
  'color-danger-secondary': 'rgba(230, 95, 70, .10)',

  'color-success-default': '#23bb69', /** 用于跌幅数字／卖出按钮／卖出控件 */
  'color-success-default-dark': '#22aa61',
  'color-success-secondary': 'rgba(52, 171, 116, .10)',

  'color-warn-default': '#ff801a', /** 用于输入框错误文字信息提示／解锁错误状态显示 */
  'color-warn-default-dark': '#e87519',
  'color-warn-secondary': '#fdf6ec',

  'color-default-default': colorDefaultDefault, /** 用于一级文字信息 如大标题文字，强调性数字信息，标题文字 */
  'color-default-default-dark': 'rgba(255, 255, 255, 0.89)',
  'color-default-secondary': colorDEefaultSecondary, /** 用于二级文字信息 */
  'color-default-secondary-dark': 'rgba(255, 255, 255, 0.6)',
  'color-default-third': '#d2d2d2', /** 用于三级文字信息 如时间信息 */
  'color-default-third-dark': 'rgba(255, 255, 255, 0.38)',

  'color-disabled-button': '#ccc', /** 按钮禁用色 */
  'color-disabled-input': '#f5f7fa', /** Input输入框禁用背景色 */
  'color-line': '#e6e6e6', /** 用于所有的线 分割线 */
  'color-line-dark': '#0f1012',
  'color-hover-default': colorHoverDefault, /** 用于鼠标悬停在列表上的颜色/表格标题底色 */
  'color-hover-stripe': colorHoverStripe, /** table 条纹底色 */

  'color-nav-hover-light': '#f5f7fa', /** nav悬停背景色-light模式 */
  'color-nav-hover-dark': '#1c1f32', /** nav悬停背景色-dark模式 */

  'color-input-bg-search': '#f8f8f8', /** 搜索输入框背景色 */
  'color-input-bg-search-dark': '#0d0d0d',

  'color-reverse': '#fff', /** 反白文字 */
  'color-reverse-dark': '#20232a',

  'font-family-cn': '"PingFangSC", "Microsoft YaHei", "sans-serif", "Tahoma"',
  'font-family-en': '"San Francisco", "Arial", "Tahoma", "Roboto", "Tahoma"',

  'font-weight-bold': 'bold', /** 加粗（标题） */
  'font-weight-normal': 'normal', /** 不加粗 */

  'shadow-underline': '0 2px 6px 0 rgba(40, 97, 246, .35)', /** 下划线box-shadow */
  'shadow-tip': shadowTip, /** 全局提示消息 文字提示 模态框等阴影 */

  'width-max': '1920px',
  'width-min': '1140px',
  'container-width-min': '1180px', /** 因为nav左右各有20px */

  'font-size-big-big': '30px', /** 用于大标题文字，信息层级较高 */
  'font-size-big-default': '18px', /** 用于导航栏标题，主要按钮文字，强调作用文字 */
  'font-size-default-big': '16px', /** 用于正文文字内容，列表标题文字，信息层级高 */
  'font-size-default-default': '14px', /** 用于正文文字内容，数字，信息层级一般 */
  'font-size-small-big': '12px', /** 用于辅助文字内容，数字，时间，信息层级弱 */
  'font-size-small-middle': '11px', /** 数字/时间 */
  'font-size-small-default': '10px', /** 底部标签栏文字 */

  /** 常用组件高，例如Button/Input等 */
  'height-lg': '40px',
  'height-md': '36px',
  'height-sm': '32px',
  'height-xs': '28px',

  /** 常用组件border-radius，例如Button/Input等 */
  'border-radius-lg': '5px',
  'border-radius-md': '4px',
  'border-radius-sm': '3px',
  'border-radius-xs': '2px',

  /** 常用组件padding，例如Button/Input等 */
  'padding-lg': paddingLg,
  'padding-md': '20px',
  'padding-sm': '15px',
  'padding-xs': '12px',

  /** 覆盖ANTD默认样式 */
  'primary-color': colorPrimaryDefault, /** 全局主色 */
  'btn-padding-base': '0 24px',
  'text-color': colorDefaultDefault,
  'tabs-horizontal-padding': '12px 0',
  'tabs-bar-margin': '0 0 20px 0',
  'tabs-horizontal-margin': '0 50px 0 0',
  'table-header-bg': colorHoverDefault,
  'table-header-color': colorDEefaultSecondary,
  'table-row-hover-bg': colorHoverStripe,
  'shadow-color': baseShadowColor,
  'shadow-2': shadowTip,
  'shadow-1-down': shadowTip,
  'input-placeholder-color': colorDEefaultSecondary,
  'input-padding-horizontal': '14px',
  'form-item-margin-bottom': paddingLg,
  'font-size-lg': '14px',
  'modal-body-padding': paddingLg
}
